// internal-deps
import { OverlayType } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export const shouldRenderLottie = (enabledOverlayType: OverlayType | null, enabledOverlayId: string): boolean => {
    return (
        isEmpty(enabledOverlayId) ||
        isEmpty(enabledOverlayType) ||
        (enabledOverlayType !== OverlayType.MODAL && enabledOverlayType !== OverlayType.HALFCARD)
    );
};
